<fui-page>
    <fui-page-pane>
        <fui-page-body>
            <fui-page-main>
                <fui-page-subject>
                    <div class="header">
                        <fui-switch-control *ngIf="showRestricted" [label]="'wbo.localisation.label.restricted'"
                                            [(ngModel)]="restricted"></fui-switch-control>
                        <wbo-localisation-outlet-selection-autocomplete [panelComponent]="outletSelectionPanel"
                                                                        *ngIf="restricted"></wbo-localisation-outlet-selection-autocomplete>
                    </div>
                    <wbo-localisation-outlet-selection [selectedOutlets]="selectedOutlets" *ngIf="restricted"
                                                       [selectedCustomObjects]="selectedCustomObjects"></wbo-localisation-outlet-selection>
                </fui-page-subject>
            </fui-page-main>
        </fui-page-body>
    </fui-page-pane>
    <fui-page-footer>
        <ng-template #FUIPageFooterButtons>
            <fui-buttons>
                <wbo-cancel-button (click)="cancelLocalisation()"></wbo-cancel-button>
                <wbo-ok-button (click)="confirmLocalisation()" [title]="'wbo.common.button.apply'"></wbo-ok-button>
            </fui-buttons>
        </ng-template>
    </fui-page-footer>
</fui-page>
